import { DEFAULT_ATTACHMENT_FEATURE_VALUES } from '@/features/feature-management/types/attachmentFeature';
import { DEFAULT_CONTENT_RESTRICTION_FEATURE_VALUES } from '@/features/feature-management/types/contentRestrictionFeature';
import { DEFAULT_ENTERTAINMENT_FEATURE_VALUES } from '@/features/feature-management/types/entertainmentFeature';
import type { FeaturesEnum } from '@/features/feature-management/types/features';
import { DEFAULT_GEO_AREA_SELECTION_FEATURE_VALUES } from '@/features/feature-management/types/geoAreaSelectionFeature';
import { DEFAULT_POLL_FEATURE_VALUES } from '@/features/feature-management/types/pollFeature';

export const FEATURE_VALUE_DEFAULTS: Record<FeaturesEnum, object> = {
  'de.fhg.iese.dd.dorffunk.new-post-tab': {},
  'de.fhg.iese.dd.dorffunk.gossip': {},
  'de.fhg.iese.dd.dorffunk.newsitem': {},
  'de.fhg.iese.dd.dorffunk.organizations.emergency-aid': {},
  'de.fhg.iese.dd.dorffunk.organizations.civil-protection': {},
  'de.fhg.iese.dd.dorffunk.suggestion': {},
  'de.fhg.iese.dd.dorffunk.suggestion.creation': {},
  'de.fhg.iese.dd.dorffunk.offer': {},
  'de.fhg.iese.dd.dorffunk.seeking': {},
  'de.fhg.iese.dd.dorffunk.happening': {},
  'de.fhg.iese.dd.dorffunk.happening.creation': {},
  'de.fhg.iese.dd.dorffunk.happening.participation': {},
  'de.fhg.iese.dd.dorffunk.happening.list-participants': {},
  'de.fhg.iese.dd.dorffunk.specialpost': {},
  'de.fhg.iese.dd.dorffunk.attachment': DEFAULT_ATTACHMENT_FEATURE_VALUES,
  'de.fhg.iese.dd.dorffunk.content.creation-restriction':
    DEFAULT_CONTENT_RESTRICTION_FEATURE_VALUES,
  'de.fhg.iese.dd.dorffunk.convenience': {},
  'de.fhg.iese.dd.dorffunk.geoarea-selection':
    DEFAULT_GEO_AREA_SELECTION_FEATURE_VALUES,
  'de.fhg.iese.dd.dorffunk.group': {},
  'de.fhg.iese.dd.dorffunk.group.creation': {},
  'de.fhg.iese.dd.dorffunk.group.accessibility.approval-required': {},
  'de.fhg.iese.dd.dorffunk.group.list-members': {},
  'de.fhg.iese.dd.dorffunk.volunteering': {},
  'de.fhg.iese.dd.dorffunk.organizations.entertainment':
    DEFAULT_ENTERTAINMENT_FEATURE_VALUES,
  'de.fhg.iese.dd.dorffunk.poll': DEFAULT_POLL_FEATURE_VALUES,
  'de.fhg.iese.dd.dorffunk.dark-mode': {},
  'de.fhg.iese.dd.dorffunk.dev-mode': {},
  'feature.local.example': {}
};
